import pulse from "@finn-no/pulse-sdk";

type TrendingHomeTrackingData = {
	id: string;
	name: string;
	position: string;
	url: string;
};

export function trackTrendingHomeClick(home: TrendingHomeTrackingData) {
	const qasaExternalContentId = `externalcontent:qasa.se:${home.id}`;

	pulse.trackEvent({
		type: "Click",
		intent: "Open",
		name: "Popular home clicked",
		object: {
			id: qasaExternalContentId,
			type: "ExternalContent",
			contentId: home.id,
			name: home.name,
			position: home.position,
			provider: "Qasa.se",
			url: home.url,
		},
		target: {
			id: home.id,
			type: "ExternalContent",
			contentId: home.id,
			name: home.name,
			provider: "Qasa.se",
			url: home.url,
		},
		vertical: {
			name: "realestate",
			subVertical: "lettings",
		},
	});
}
